import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate ,Link} from 'react-router-dom';
import Navbarp from '../Components/CommonComponents/Navbarp';
import SideNav from '../Components/CommonComponents/SideNav';
import { TextField, Grid } from '@mui/material';
import { useState,useEffect } from 'react';
import PagesNumber from '../Components/CommonComponents/PagesNumber';
import {BASE_URL} from '../Config/Config';
import { getLogin, getToken, logout } from '../features/Loginuser';
import { setplans } from '../features/Plan';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Form from 'react-bootstrap/Form';
import '.././css/List.css'
import '.././css/Card.css'
import { formatdate } from '../Common/Dateformat';
import PlanList from '../Components/List/PlanList';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Loader from '../Components/CommonComponents/Loader';
import DialogModal from '../Components/CommonComponents/DialogModal';
import Calendar from '../Components/CommonComponents/Calendar';


function Plans() {
  const dispatch=useDispatch();
  const [startdate, setstartdate] =useState("");
  const[enddate,setenddate]=useState("");
  const [list, setList] = useState([]);
  const login = useSelector(getLogin);
  const token=useSelector(getToken);
  const [lastPage, setLastPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const[totalplan,setTotalPlans]=useState(0) 
  const [count, setCount] = useState(0);
  const [sortingby,setSortingBy]=useState(1)
  const [loading,setLoading]=useState(true);
  const [show,setShow]=useState(false);
  const [message,setMessage]=useState("");
  const [planid,setPlanId]=useState(null);
  const [type,setType]=useState("")
  const [actionLoader,setActionLoader]=useState(false)
  const [firstLoading,setFirstLoading]=useState(true)
  const [searchBy,setSearchBy]=useState({
      "records":100,
      "startdate":"",
      "enddate":""
    });
  useEffect(() => { 
      
    if(firstLoading){
      getplanlist();
      setFirstLoading(false)
    }else{
      const getData = setTimeout(() => {
        getplanlist();
      }, 500)
      return () => clearTimeout(getData)
    }
      
  }, [currentPage,searchBy])
  function getplanlist(){
    let searchstr=searchstring(searchBy);
      fetch(BASE_URL+"plans?page="+currentPage+"&"+searchstr, {
          method: "GET",
          headers: {
            //'X-XSRF-TOKEN': 'XSRF-TOKEN)',
                'Accept': 'application/json',
              'Content-Type': 'application/json',
              "Authorization": "Bearer "+token,
          }

          })
          
          .then((response) => {
            if (response.status===401){
              dispatch(logout());
            }else{
              return response.json()
            }
          })
          //Then with the data from the response in JSON...
          .then((data) => { 
              setType("status")
              setLoading(false)
              setList(data.result.data);
              dispatch(setplans(data.result.data))
              setLastPage(data.result.last_page);
              setCurrentPage(data.result.current_page);
              setTotalPlans(data.totalPlan);
              setCount(data.count)
              
          })
  }

  function deletePlan(plan_id){
    var fdata =new FormData();
    fdata.append("plan_id",plan_id)
      fetch(BASE_URL+"deleteplan", {
        method: "POST",
        headers: {
          //'X-XSRF-TOKEN': 'XSRF-TOKEN)',
              'Accept': 'application/json',
            "Authorization": "Bearer "+token,
        },
        body:fdata,
        })
        
        .then((response) => {
          if (response.status===401){
            dispatch(logout());
          }else{
            return response.json()
          }
        })
        //Then with the data from the response in JSON...
        .then((data) => {
          setType("status")
          setShow(true)
          setMessage(data.message)
          setActionLoader(false)
            
        })
        getplanlist();
  }

    function setpage(value){
      if (value >=1&& value<=lastPage){
          setCurrentPage(value)
      }
    }
    function searchParam(value,key){
     setSearchBy({...searchBy,[key]:value})
    }
    const searchstring=(searchBy)=>{
      let passdata={...searchBy};
      if(searchBy.startdate!=null && searchBy.enddate!=null){
        passdata.startdate=searchBy.startdate;
        passdata.enddate=searchBy.enddate;
      }
      var queryString = Object.keys(passdata).map(key => key + '=' + passdata[key]).join('&');
      return queryString
    }
    var arr=[...list]
    function sort(type,key){
      if(sortingby==1){
        //code for sorting on server 
        setSearchBy({...searchBy,"sortby":key,"sorttype":type});
      }else{
      // Code for sorting in browser 
        if (type=="asc"){
         for (let i=0;i<arr.length;i++){
             for (let j=0;j<=i;j++){
                 if (arr[i][key] < arr[j][key]) {
                     var x = arr[i];
                     arr[i] =arr[j];
                     arr[j] = x;
                 }
             }
         }
      }
      if (type=="desc"){
         for (let i=0;i<arr.length;i++){
             for (let j=0;j<=i;j++){
                 if (arr[i][key] >arr[j][key]) {
                     var x = arr[i];
                     arr[i] =arr[j];
                     arr[j] = x;
                 }
             }
         }
       }
     setList(arr);
      }
    }
    function confirmPlanId(plan_id){
      setType("confirm")
      setMessage("Are you Sure you Want to delete the Plan")
      setShow(true);
      setPlanId(plan_id);
  }
    function showModel(show,descision,id){
      setShow(show);
      if(descision){
        deletePlan(id);
        setActionLoader(true)
      }else{
        setPlanId(null);
      }
    }
    if(login==null||login==false){
    return  <Navigate to="/" replace={true} />
    }
     return (
       <>
       <DialogModal 
        show={show} 
        message={message} 
        action={showModel} 
        id={planid} 
        type={type}
        actionLoader={actionLoader}
       />
         <div className="container-fluid ps-0 pe-0">
           <div className="row">
             <div>
             <Navbarp />
             </div>
             <div className='position-absolute' >
                <div className='mt-1'>
                <Grid container className='justify-content-between ms-3'  >
                  <div className='d-md-flex width_100 me-3'>
                        <Grid item className='me-3 mt-2'>
                          <Card className='record' >
                            <CardContent>
                              <Typography variant="h6" gutterBottom>
                                 Record Found
                              </Typography>
                               <Typography variant="h6" gutterBottom>
                                 {count}
                              </Typography>
                            </CardContent>   
                          </Card>
                        </Grid>
                        <Grid item className='me-3 mt-2'>
                          <Card className='total'>
                            <CardContent>
                              <Typography variant="h6" gutterBottom>
                                 Total Plans
                              </Typography>
                              <Typography variant="h6" gutterBottom>
                                 {totalplan}
                              </Typography>
                            </CardContent>   
                          </Card>
                        </Grid>
                    </div>
                    <div>
                      <Grid container className='justify-content-between' >
                                     <Link to="addplan" replace={true} >
                                        <button type="button" className="btn btn-success mt-4 mb-2 ms-2">
                                          <i className="bi bi-plus-lg me-1"/>
                                            Add Plan
                                        </button>
                                      </Link>
                                      <Calendar
                                        searchBy={searchBy} 
                                        setSearchBy={setSearchBy}
                                        setSortingBy={setSortingBy}
                                        lastPage={lastPage} 
                                        currentPage={currentPage} 
                                        setpage={setpage} 
                                      />
                            </Grid>
                  </div>
                </Grid>
                  {loading?
                   <Loader/>:                             
                  <div>
                  <PlanList data={list} searchParam={searchParam} sort={sort} confirmPlanId={confirmPlanId}/>
                  </div>
                  }
                  
                </div>       
             </div>
           </div>
         </div>
       </>
     );
}

export default Plans